import axios from 'axios'

const isNewVersion = () => {
    let url = './static/js/version.json?t=' + new Date().getTime();
    // let url = 'http://localhost:8080/version.json'
    // console.log('版本号222', window.location, url)
    axios.get(url).then(res => {

        if (res.status === 200) {
            let vueVersion = res.data.version;

            let localVueVersion = localStorage.getItem('vueVersion');
            console.log('版本号', res.data, '缓存版本号', localVueVersion)
            if (localVueVersion != vueVersion) {
                // if (localVueVersion != null && localVueVersion != undefined && localVueVersion && localVueVersion != vueVersion) {
                localStorage.setItem('vueVersion', vueVersion);
                // window.location.reload();
                location.reload();
                return;
            } else {
                localStorage.setItem('vueVersion', vueVersion);
            }
        }
    });
}

export default {
    isNewVersion
}


// WEBPACK FOOTER //
// ./src/util/versionUpdate.js